import { create } from 'zustand';

interface ApplicationSettingsState {
  settingsOpen: boolean;
  openSettings: () => void;
  closeSettings: () => void;
}

export const useApplicationSettings = create<ApplicationSettingsState>((set) => ({
  settingsOpen: false,
  openSettings: () => set({ settingsOpen: true }),
  closeSettings: () => set({ settingsOpen: false }),
}));
